import React from "react";
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  a {
    ${tw`underline text-blue-600 hover:text-blue-800 visited:text-purple-600`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ol {
    ${tw`list-decimal list-outside ml-5`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "個人情報保護方針" }) => {
  return (
    <AnimationRevealPage>
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>
              鎌倉情報技術株式会社（以下、「当社」といいます。）は、本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）における、
              ユーザーの個人情報の取り扱いについて、以下の通り個人情報保護方針（以下、「本方針」といいます。）を定めます。
            </p>

            <h2>1. 個人情報</h2>
            <p>
              本方針における「個人情報」とは、本サービス等を通じてユーザーから収集させていただく、
              氏名、電話番号、メールアドレス等、ユーザー個人を識別できる情報を指します。
            </p>

            <h2>2. 個人情報の収集</h2>
            <p>
              当社は、ユーザーがお問い合わせをする際に氏名、電話番号、メールアドレスを収集させていただきます。
            </p>

            <h2>3. 個人情報の利用</h2>
            <p>当社が個人情報を収集・利用する目的は下記の通りです。</p>
            <ol>
              <li>当社サービスの提供・運営のため</li>
              <li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
              <li>ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等および当社が提供す他のサービスの案内のメールを送付するため</li>
              <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
              <li>利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
              <li>有料サービスにおいて、ユーザーに利用料金を請求するため</li>
              <li>上記の利用目的に付随する目的のため</li>
            </ol>

            <h2>4. Cookieその他の技術の利用</h2>
            <ol>
              <li>
                当社は、本サービスの提供に際して、Cookieおよびこれに類する技術を利用することがあります。
                当社は、ユーザーのCookie情報、ユーザーが閲覧した広告およびウェブページならびにユーザーの利用環境等の情報を
                自動的にユーザーのウェブブラウザから取得し、サーバーに記録することで、本サービスの利用状況等を把握し、
                本サービスの品質を向上させるためにこれらの情報を用いることがあります。
              </li>
              <li>
                Cookieを無効化したいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。
                ただしCookieを無効化すると、本サービスを正常に利用できない場合があります。
              </li>
              <li>
                当社は
                <a
                  href="https://marketingplatform.google.com/intl/ja/about/analytics/"
                  target="_blank"
                  rel="noopener noreferrer"
                >Google Analytics
                </a>
                を用いて、本サービスの利用状況および広告効果等の情報解析を行います。
                <a
                  href="https://marketingplatform.google.com/intl/ja/about/analytics/"
                  target="_blank"
                  rel="noopener noreferrer"
                >Google Analytics
                </a>
                は個人を特定する情報を含むことなくユーザー情報を収集し、収集された情報は
                <a
                  href="https://marketingplatform.google.com/intl/ja/about/analytics/"
                  target="_blank"
                  rel="noopener noreferrer"
                >Google Analytics
                </a>
                の定めるプライバシーポリシーその他規定に管理されます。
              </li>
            </ol>

            <h2>5. 個人情報の第三者提供</h2>
            <p>当社は、以下の各号に定める場合を除き、ユーザーの個人情報を開示いたしません。</p>
            <ol>
              <li>ユーザーの事前の同意・承諾を得た場合</li>
              <li>法令等に基づき開示を求められた場合</li>
              <li>当社、その他の第三者等の権利、財産等を保護するために当社が個人情報を開示せざるをえないと判断した場合</li>
            </ol>

            <h2>6. 個人情報の訂正および削除</h2>
            <ol>
              <li>
                ユーザーは、当社の保有する個人情報が誤った情報である場合には、当社が定める手続きにより、
                当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
              </li>
              <li>当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。</li>
              <li>当社は、前項の規定に基づき訂正等を行なった場合、または訂正等を行わない旨の決定をした場合は、遅滞なくこれをユーザーに通知します。</li>
            </ol>

            <h2>7. 個人情報保護方針の変更</h2>
            <ol>
              <li>本方針の内容は、法令に定めのある事項を除いて、ユーザーに通知することなく、変更できるものとします。</li>
              <li>法令に定めのある事項の変更を行なった場合には、当社所定の方法によりユーザーに通知し、また本ウェブサイト上に公表するものとします。</li>
              <li>当社が別途定める場合を除いて、変更後の個人情報保護方針は、本ウェブサイトに掲載した時点から効力を生じるものとします。</li>
            </ol>

            <h2>8. お問い合わせ窓口</h2>
            <p>本方針に関するお問い合わせは、本ウェブサイトの<a href="/#contact">お問い合わせページ</a>までお願いいたします。</p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
    </AnimationRevealPage>
  );
};
